module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-SemiBold.1bc52b4a.ttf";